import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LocalizationProvider, useLocalization } from '@/contexts/LocalizationContext';
import { RequestHeader } from './RequestHeader';
import { RequestFooter } from './RequestFooter';

type RequestLayoutProps = {
  children: React.ReactNode;
};

function BackToLogin() {
  const { t, locale } = useLocalization();
  const isRTL = locale === 'ar';

  return (
    <div className="max-w-5xl mx-auto px-4 pt-4 sm:pt-6">
      <Link
        to="/login"
        className="group inline-flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-primary transition-colors rounded-lg px-3 py-2 -ms-3 hover:bg-primary/5"
      >
        <ArrowLeft className={`h-4 w-4 transition-transform ${isRTL ? 'rotate-180 group-hover:translate-x-0.5' : 'group-hover:-translate-x-0.5'}`} />
        {t('auth.backToLogin')}
      </Link>
    </div>
  );
}

export const RequestLayout: React.FC<RequestLayoutProps> = ({ children }) => {
  return (
    <LocalizationProvider>
      <div className="min-h-screen flex flex-col bg-[#FDFBFB]">
        <RequestHeader />

        <main className="flex-1">
          <BackToLogin />
          <div className="max-w-5xl mx-auto px-4 py-4 sm:py-6">{children}</div>
        </main>

        <RequestFooter />
      </div>
    </LocalizationProvider>
  );
};
